import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const PlusIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M10.98 19.28V12.98H4.68V10.94H10.98V4.64H13.02V10.94H19.32V12.98H13.02V19.28H10.98Z" />
    </SvgIcon>
  );
});
